import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { GlassCard } from '../components/ui';
import { MarketingForm } from '../components/forms/MarketingForm';
import { MyRequestsList } from '../components/forms/MyRequestsList';
import { isOidcConfigured } from '../lib/auth';

export function MarketingFormPage() {
  const showSidebar = isOidcConfigured();

  return (
    <div className="min-h-screen flex flex-col w-full min-w-0">
      <Header showBackButton backHref="/portal" />

      <main className="flex-1 w-full min-w-0 container mx-auto px-4 py-8 pb-16 max-w-6xl">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Marketing Request
          </h1>
          <p className="text-gray-600">
            Submit a request for marketing collateral, trade shows, or promotional materials
          </p>
        </div>

        <div className={showSidebar ? 'grid grid-cols-1 lg:grid-cols-5 gap-6 items-start' : 'max-w-2xl mx-auto'}>
          {/* ── Form ────────────────────────────────────────────────── */}
          <div className={showSidebar ? 'lg:col-span-3' : undefined}>
            <GlassCard className="p-6 md:p-8" hoverable={false}>
              <MarketingForm />
            </GlassCard>
          </div>

          {/* ── My Requests sidebar ──────────────────────────────────── */}
          {showSidebar && (
            <div className="lg:col-span-2">
              <GlassCard className="p-5" hoverable={false}>
                <MyRequestsList />
              </GlassCard>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
}
